import { createFileRoute } from "@tanstack/react-router";
import CTASection from "./_components/CTASection";
import FeaturesSection from "./_components/FeaturesSection";
import HeroSection from "./_components/HeroSection";
import WorkflowSection from "./_components/WorkflowSection";

export const Route = createFileRoute("/_public/")({
  component: Index,
});

function Index() {
  return (
    <div className="flex-1 container mx-auto flex flex-col px-6">
      <HeroSection />
      <FeaturesSection />
      <WorkflowSection />
      <CTASection />
    </div>
  );
}
